import { gql } from 'apollo-boost';

export const PATCH_ASSIGNMENT_MUTATION = gql`
    mutation patchAssignment($input: PatchAssignmentInput!) {
        result: patchAssignment(input: $input) {
            id
            status
            score
            scormState
            createdAt
            updatedAt
        }
    }
`;

// # --------------------------------------------------------------------------
// # PatchAssignmentInput
// #
// # Input for a student to log activity against an Assignment.
// # --------------------------------------------------------------------------
//   input PatchAssignmentInput {
//     learningObjectID: UUID!
//     courseID: UUID!
//     status: LearningStatusEnum!  ** ASSIGNED, IN_PROGRESS, COMPLETED **
//     score: Int
//     scormState: JSON
//     timeSpent: Int
//   }
